import React from "react";
import styled from "styled-components";

const TableScrollWrapper = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.thead`
  background: #f5f5f5;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background: #f9f9f9;
  }
  &:hover {
    background: #f0f0f0;
  }
`;

const TableHeaderCell = styled.th`
  padding: 12px;
  text-align: left;
  font-weight: bold;
  border-bottom: 2px solid #ddd;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

const TableCell = styled.td`
  padding: 12px;
  border-bottom: 1px solid #eee;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

const MetricBadge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  background: #e3f2fd;
  color: #1976d2;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 5px;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

const EventPerformance = ({ data, loading }) => {
  if (loading) {
    return <LoadingMessage>Loading data...</LoadingMessage>;
  }

  if (!data || data.length === 0) {
    return <LoadingMessage>No event performance data available.</LoadingMessage>;
  }

  const getMetricCount = (metrics, metricType) => {
    const metric = metrics.find((m) => m.metricType === metricType);
    return metric ? metric.count : 0;
  };

  return (
    <TableScrollWrapper>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>Event Slug</TableHeaderCell>
            <TableHeaderCell>Total Events</TableHeaderCell>
            <TableHeaderCell>Unique Visitors</TableHeaderCell>
            <TableHeaderCell>Metrics</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <tbody>
          {data.map((event, index) => (
            <TableRow key={event.eventId || index}>
              <TableCell>{event.eventSlug || event.eventId || "N/A"}</TableCell>
              <TableCell>{event.totalEvents.toLocaleString()}</TableCell>
              <TableCell>{event.uniqueVisitors.toLocaleString()}</TableCell>
              <TableCell>
                {event.metrics.map((metric, idx) => (
                  <MetricBadge key={idx}>
                    {metric.metricType}: {metric.count}
                  </MetricBadge>
                ))}
              </TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </TableScrollWrapper>
  );
};

export default EventPerformance;

